<script setup lang="ts">
import type { BeltColor } from '@@/bits/belt_colors'
import { getBeltTextOutlineColorHex, getUntranslatedBeltCertificateDescription } from '@@/bits/belt_colors'
import { computed } from 'vue'

const { color = 'yellow', sizePreset = CertificateSubtitleSizePreset.Display } = defineProps<{
  color: Exclude<BeltColor, 'white'>
  sizePreset: CertificateSubtitleSizePreset
}>()

const subtitle = computed(() => {
  return getUntranslatedBeltCertificateDescription(color)
})

const textOutlineColor = computed(() => {
  return getBeltTextOutlineColorHex(color)
})

const textOutlineStyle = computed(() => {
  return sizePreset === CertificateSubtitleSizePreset.Display
    ? {
        '-webkit-text-stroke': `1px ${textOutlineColor.value}`,
        'paint-order': 'stroke fill',
      }
    : undefined
})
</script>

<script lang="ts">
export enum CertificateSubtitleSizePreset {
  Display = 'display',
  Print = 'print',
}

export default {}
</script>

<template>
  <p
    :class="[
      'm-0',
      'select-none pointer-events-none',
      'text-subtitle',
      // position
      sizePreset === CertificateSubtitleSizePreset.Display ? '' : 'translate-s-3',
      color === 'black' ? 'text-light-text-100' : 'text-dark-text-100',
    ]"
    :style="textOutlineStyle"
  >
    {{ subtitle }}
  </p>
</template>

<style scoped lang="scss">
@import '@@/styles/eb_garamond.scss';

.text-subtitle {
  font-family: 'EB Garamond';
  font-weight: 500; /* goodcheck-disable-line */
  font-size: 9px;
  line-height: 10px;
  text-align: center;
  text-wrap: balance;
}
</style>
